// @flow
import * as React from 'react';
import {ImArrowRight2} from "react-icons/im";


export default function Header(props) {
    return (
        <React.Fragment>
            <header className="navbar px-2 navbar-dark bg-white  bd-navbar actionbar rtl fixed-top max-w-lg text-center ">



                   <div className="w-100 float-right text-small-1">
                       {props.title}
                   </div>

                {
                    props.hasBack &&
                    <div className="position-absolute" onClick={() => {props.backAddress ? window.location.replace(props.backAddress) :  window.history.back()} }>
                        <ImArrowRight2 />
                    </div>
                }

            </header>
        </React.Fragment>
    );
};